import React, {useEffect, useState} from 'react';

import {openFavoritesLimitReachedModalSignal} from '../signals/CallHistory.signals';
import {FavoritesLimitReachedModal as FavoritesLimitReachedModalView} from '../views/FavoritesLimitReachedModal/FavoritesLimitReachedModal.view';

export const FavoritesLimitReachedModal: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(
        () => openFavoritesLimitReachedModalSignal.add(() => setIsOpen(true)),
        [],
    );

    return (
        <FavoritesLimitReachedModalView
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
        />
    );
};
